/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-09-10 10:48:44
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { TYPEFORM_SURVEY, LIMIT_SHOW_SURVEY_PER_DAY } from 'src/constants/typeform-survey';
import { getShop } from 'src/helpers';

type Props = WithI18nProps;
class TypeFormEmbeded extends Component<Props> {
  state = {
    isSubmited: false,
    numberOfViews: 0
  };

  componentWillMount() {
    const { type } = this.props;
    const { enabledFrom, enabledTo, link } = TYPEFORM_SURVEY[type];
    if (this.checkEnabledTime(enabledFrom, enabledTo)) {
      // Get data from local storage
      try {
        const typeFormDataLocalStorage = localStorage.getItem(`${getShop()}-TypeForm_${type}`);
        const typeFormData = typeFormDataLocalStorage ? JSON.parse(typeFormDataLocalStorage) : {};
        const { isSubmited = false, numberOfViews = 0, day = 0, surveyLink = '' } = typeFormData;
        let dataState = { isSubmited: false, numberOfViews: 0 };
        // Check link on local storage is the same with current survey
        if (link === surveyLink) {
          // Update isSubmited state
          dataState.isSubmited = isSubmited;

          // Check day on local storage day is today
          const today = new Date().setHours(0, 0, 0, 0);
          const localStorageDay = new Date(day).setHours(0, 0, 0, 0);
          if (today === localStorageDay) {
            dataState.numberOfViews = numberOfViews;
          }

          // Update state
          this.setState(dataState);
        }
      } catch (error) {}

      // Handle when reload or leave page
      window.addEventListener('unload', this.handleLeavePage);
    }
  }

  componentWillUnmount() {
    this.handleLeavePage();

    // Handle when reload or leave page
    window.removeEventListener('unload', this.handleLeavePage);
  }

  handleLeavePage = () => {
    const { type } = this.props;
    const { enabledFrom, enabledTo, link } = TYPEFORM_SURVEY[type];

    if (this.checkEnabledTime(enabledFrom, enabledTo)) {
      // Insert data to local storage
      try {
        const { isSubmited, numberOfViews } = this.state;
        const typeFormData = {
          isSubmited,
          numberOfViews,
          day: new Date().getTime(),
          surveyLink: link
        };
        localStorage.setItem(`${getShop()}-TypeForm_${type}`, JSON.stringify(typeFormData));
      } catch (error) {}
    }
  };

  componentWillReceiveProps(nextProps: Props) {
    const { conditionShow = false, conditionShowStateChange = false } = this.props;
    const {
      conditionShow: nextConditionShow = false,
      conditionShowStateChange: nextConditionShowStateChange = false
    } = nextProps;

    if (
      (!conditionShow && nextConditionShow) ||
      conditionShowStateChange !== nextConditionShowStateChange
    ) {
      this.openForm();
    }
  }
  render() {
    const { type, email, tenantId, i18n } = this.props;
    const { enabledFrom, enabledTo, link, mode } = TYPEFORM_SURVEY[type];
    const fullLink = tenantId ? `${link}?tenantid=${tenantId}&email=${email}` : link;

    return this.checkEnabledTime(enabledFrom, enabledTo) ? (
      <div>
        <ReactTypeformEmbed
          popup
          mode={mode}
          autoOpen={false}
          url={fullLink}
          hideHeaders
          hideFooter
          buttonText={i18n.translate('AdminHTML.Common.Action.go')}
          style={{ width: 0, height: 0 }}
          opacity={50}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
          onSubmit={() => {
            this.onSubmitSurvey();
          }}
        />
      </div>
    ) : (
      ''
    );
  }

  // Call to open form survey
  openForm = () => {
    const { type } = this.props;
    const { enabledFrom, enabledTo } = TYPEFORM_SURVEY[type];
    const { isSubmited, numberOfViews } = this.state;
    if (
      this.checkEnabledTime(enabledFrom, enabledTo) &&
      !isSubmited &&
      numberOfViews < LIMIT_SHOW_SURVEY_PER_DAY
    ) {
      this.setState({ numberOfViews: numberOfViews + 1 });
      this.typeformEmbed.typeform.open();
    }
  };

  // Ubdate state when submit survey
  onSubmitSurvey = () => {
    this.setState({ isSubmited: true });
  };

  checkEnabledTime = (from: string, to: string) => {
    const today = moment();

    // If from, to is empty, return true
    if (_.isEmpty(from) && _.isEmpty(to)) {
      return true;
    }

    const fromDate = moment(from);
    const toDate = moment(to);

    return today.isBefore(toDate) && today.isAfter(fromDate);
  };
}

export default withI18n()(TypeFormEmbeded);
